// LogoutConfirmationDialog.js
import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

function LogoutConfirmationDialog({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ height: "180px" }}>
        <DialogContent style={{ marginTop: "20px" }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "auto",
            marginTop: "10px",
          }}
        >
          <Button
            onClick={onClose}
            color="primary"
            variant="contained"
            style={{ color: "white" }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            color="primary"
            autoFocus
            style={{ color: "white", backgroundColor: "#CF5C5C" }}
            variant="contained"
          >
            Logout
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default LogoutConfirmationDialog;
